import React, {useState, useEffect} from 'react';
import {MiPaciente} from '../Pacientes/MiPaciente';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {useSessionStore} from '../../hooks/useSessionStore';
import {FormularioMisPacientes} from './FormularioMisPacientes';
import axios from 'axios';
import {ModalesMisPacientes} from './ModalesMisPacientes';
import {animateScroll as scroll} from 'react-scroll';
import {useParams} from 'react-router-dom';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';

export const ContentMisPacientes = (props) => {
	const {MenuLateralAux, chageMenuLateralAux} = props;

	const {goTo} = useParams();

	/* Using the useSessionStore hook to set the state of the UsuarioContext. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	/* Setting the state of the `ListaUsuarios` variable to the value of the `ListaUsu()` function. */
	const [ListaPacientes, setListaPacientes] = useState([]);

	const [Modo, setModo] = useState('normal');

	/* Creating a state variable called ErroresFormulario and a function to update it called setErroresFormulario. */
	const [ErroresFormulario, setErroresFormulario] = useState([]);

	/* Creating a state variable called ModalErrores and setting it to false. */
	const [ModalErrores, setModalErrores] = useState(false);

	const [ModalCorrecto, setModalCorrecto] = useState(false);

	const [ModalBorrarPaciente, setModalBorrarPaciente] = useState(false);

	const [ModalPacienteDelteOk, setModalPacienteDelteOk] = useState(false);

	const [ModalPacienteDelteNoOk, setModalPacienteDelteNoOk] = useState(false);

	const [viewFormPaciente, setViewFormPaciente] = useState(false);

	const [idPaciente, setIdPaciente] = useState();

	const [Paciente, setPaciente] = useState({numeroSS: ''});

	const abrirPerfil = (idPaciente) => {
		setPaciente(idPaciente);
		setIdPaciente(idPaciente.id);
		setViewFormPaciente(true);
	};
	const cambiarEstado = (idPaciente) => {
		let listaAxu = [];
		ListaPacientes.map((paciente) => {
			if (paciente.id === idPaciente) {
				paciente.estado = !paciente.estado;
			}
			listaAxu.push(paciente);
		});
		setListaPacientes(listaAxu);
	};
	const cambiarTodosEstados = (idPaciente) => {
		let listaAxu = [];
		ListaPacientes.map((paciente) => {
			paciente.estado = true;
			listaAxu.push(paciente);
		});
		setListaPacientes(listaAxu);
	};

	const getPacientes = () => {
		setListaPacientes([]);
		axios({
			method: 'get',
			url: window.ipdirection + 'pacienteByCliente/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				getFotoPaciente(response.data.results);
			})
			.catch((error) => {
				console.log(error);
			});
	};
	const getFotoPaciente = (lista) => {
		let listaPacientes = [];
		lista.map((paciente) => {
			axios({
				method: 'get',
				url: window.ipdirection + 'imagenPerfilPaciente/?paciente_id=' + paciente.id,
				headers: {
					Authorization: 'Bearer ' + Usuario.access,
				},
			})
				.then((response) => {
					axios({
						method: 'get',
						url:
							window.ipdirection +
							'imagenPerfilPaciente/' +
							response.data[0].id +
							'/',
						headers: {
							Authorization: 'Bearer ' + Usuario.access,
						},
						responseType: 'blob',
					})
						.then((response2) => {
							paciente = {
								...paciente,
								fotoPaciente: URL.createObjectURL(response2.data),
							};
							listaPacientes.push({...paciente, estado: true});
							setListaPacientes([...listaPacientes]);
						})
						.catch((error) => {
							// si no existe la foto cargamos una por default
							paciente = {
								...paciente,
								fotoPaciente:
									'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images',
							};
							listaPacientes.push({...paciente, estado: true});
							console.log(error);
						});
				})
				.catch((error) => {
					// si no existe la foto cargamos una por default
					paciente = {
						...paciente,
						fotoPaciente:
							'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images',
					};
					listaPacientes.push({...paciente, estado: true});
					setListaPacientes([...listaPacientes]);
					console.log(error);
				});
		});
	};

	const modificarDatosPaciente = () => {
		let data = {
			...Paciente,
			usuario_id: Usuario.cliente.usuario.id,
		};
		console.log('data ',data)
		axios({
			method: 'patch',
			url: window.ipdirection + 'pacienteByCliente/' + Paciente.id + '/',
			data: data,
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				// Actulizamos la lista de pacientes y mostramos el mensaje de todo ok
				getPacientes();
				setModalCorrecto(true);
				scroll.scrollToTop();
			})
			.catch((error) => {
				let listaErrores = [];
				let data = error.response.data;
				let claves = Object.keys(data); // claves = ["nombre", "color", "macho", "edad"]
				for (let i = 0; i < claves.length; i++) {
					let clave = claves[i];
					listaErrores.push(clave + ' : ' + data[clave][0]);
				}
				setErroresFormulario(listaErrores);
				setModalErrores(true);
			});
	};

	const sendEmailNewPaciente = (id) => {
		axios({
			method: 'get',
			url: window.ipdirection + 'sendEmailNewPaciente/?paciente_id=' + id,
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {})
			.catch((error) => {
				console.log(error);
			});
	};
	const nuevoPaciente = () => {
		let data = {
			...Paciente,
			usuario_id: Usuario.cliente.usuario.id,
		};
		//delete data.fotoPaciente;
		axios({
			method: 'post',
			url: window.ipdirection + 'pacienteByCliente/',
			data: data,
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				cambiarFotoPerfil(response.data.data.id);
				sendEmailNewPaciente(response.data.data.id);
			})
			.catch((error) => {
				setErroresFormulario([error]);
				setModalErrores(true);
			});
	};
	/**
	 * A function that is called when the user clicks on the "Guardar Cambios" button.
	 */
	const guardarCambios = () => {
		// se comprueba si se guarda los datos de un paciente exitente o se crea uno nuevo
		if (idPaciente === undefined) {
			nuevoPaciente();
		} else {
			modificarDatosPaciente();
		}
	};

	useEffect(() => {
		scroll.scrollToTop();
		getPacientes();
		if (goTo !== null) {
			if (goTo !== undefined) {
				setViewFormPaciente(true);
			} else {
				setViewFormPaciente(false);
			}
		} else {
			setViewFormPaciente(false);
		}
	}, []);

	const borrarPacientesSeleccionados = () => {
		ListaPacientes.map((paciente) => {
			paciente.estado === false && borrarPaciente(paciente);
		});
	};
	const borrarPaciente = (idPaciente) => {
		ListaPacientes.map((paciente) => {
			if (paciente.id === idPaciente) {
				setPaciente(paciente);
			}
		});
		setModalBorrarPaciente(true);
	};

	const deletePaciente = () => {
		axios({
			method: 'delete',
			url: window.ipdirection + 'pacienteByCliente/' + Paciente.id + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				setPaciente({});
				getPacientes();
				setModalPacienteDelteOk(true);
			})
			.catch((error) => {
				console.log(error);
				setModalPacienteDelteNoOk(true);
			});
	};
	const cambiarFotoPerfil = (id) => {
		const formData = new FormData();
		const imagenOriginal = new Image(); // Crear un objeto imagen
		imagenOriginal.src = Paciente.fotoPaciente; // Cargar la imagen en el objeto

		// Esperar a que la imagen se cargue
		imagenOriginal.onload = () => {
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');

			// Definir la resolución deseada
			const ancho = 300; // ancho deseado
			const alto = 300; // alto deseado

			canvas.width = ancho;
			canvas.height = alto;

			// Set image scale
			let scaleFactor = Math.max(
				canvas.width / imagenOriginal.width,
				canvas.height / imagenOriginal.height
			);

			// Finding the new width and height based on the scale factor
			let newWidth = imagenOriginal.width * scaleFactor;
			let newHeight = imagenOriginal.height * scaleFactor;

			// get the top left position of the image
			// in order to center the image within the canvas
			let x = canvas.width / 2 - newWidth / 2;
			let y = canvas.height / 2 - newHeight / 2;

			ctx.drawImage(imagenOriginal, x, y, newWidth, newHeight);

			canvas.toBlob((blob) => {
				//formData.append("documento", File);
				formData.append('imagen', blob, Paciente.nombrePaciente + '.png');
				formData.append('nombre', 'FotoPerfil-' + Paciente.nombrePaciente);
				//formData.append("nombre", "Prueba");
				formData.append('paciente_id', id);

				axios
					.post(window.ipdirection + 'imagenPerfilPaciente/', formData, {
						headers: {
							Authorization: 'Bearer ' + Usuario.access,
						},
					})
					.then((response) => {
						getPacientes();
						setModalCorrecto(true);
						scroll.scrollToTop();
					})
					.catch((error) => {
						setErroresFormulario([
							'Error al enviar la foto del paciente' + error.toString(),
						]);
					});
			});
		};
	};

	return (
		<>
			<MenuLateralAB
				seleccionado={13}
				MenuLateralAux={MenuLateralAux}
				chageMenuLateralAux={chageMenuLateralAux}
			/>
			<div className={'contentMisPacientes' + viewFormPaciente}>
				{!viewFormPaciente ? (
					<div className='listaPacientes'>
						<div className='titleMisPacientes'>
							<div className='tilte centrador'>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='40'
									height='40'
									fill='currentColor'
									className='bi bi-person-rolodex'
									viewBox='0 0 16 16'
								>
									<path d='M8 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z' />
									<path d='M1 1a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h.5a.5.5 0 0 0 .5-.5.5.5 0 0 1 1 0 .5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5.5.5 0 0 1 1 0 .5.5 0 0 0 .5.5h.5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H6.707L6 1.293A1 1 0 0 0 5.293 1H1Zm0 1h4.293L6 2.707A1 1 0 0 0 6.707 3H15v10h-.085a1.5 1.5 0 0 0-2.4-.63C11.885 11.223 10.554 10 8 10c-2.555 0-3.886 1.224-4.514 2.37a1.5 1.5 0 0 0-2.4.63H1V2Z' />
								</svg>
								<b>Usuarios</b>
							</div>
							<div className='centrador-Botones-Registro-Empresa'>
								{/*
                                    (Modo === "noNormal")
                                        ? <div className='button borrarCuenta' onClick={() => {
                                            //modal borrar
                                            cambiarTodosEstados();
                                            setModo("normal")
                                        }}><b>Eliminar Pacientes</b></div>
                                        : <div className='button' onClick={() => {
                                            cambiarTodosEstados();
                                            setModo("noNormal");
                                        }}><b>Seleccionar Pacientes</b></div>
                                    */}
								<div
									className='button'
									onClick={() => abrirPerfil('')}
								>
									<b>Nuevo</b>
								</div>
							</div>
						</div>
						<div className='separadorPacients' />
						{ListaPacientes.map((paciente, id) => (
							<>
								<MiPaciente
									key={paciente.id}
									fotPantallaPerileccionUsuario={paciente.direccionUsuario}
									fotoPaciente={paciente.fotoPaciente}
									nombreUsuario={paciente.nombrePaciente}
									idPaciente={paciente.id}
									direccionUsuario={paciente.direccionPaciente}
									telefonoUsuario={paciente.telefonoPaciente}
									codPostUsuario={paciente.codigoPostalPaciente}
									dni={paciente.dniPaciente}
									abrirPerfil={() => {
										abrirPerfil(paciente);
										scroll.scrollToTop();
									}}
									Modo={Modo}
									estado={paciente.estado}
									cambiarEstado={cambiarEstado}
									borrarPaciente={borrarPaciente}
								/>
								<div className='separadorPacients' />
							</>
						))}
					</div>
				) : (
					<FormularioMisPacientes
						setPantallaPerfil={() => {
							setViewFormPaciente(false);
						}}
						idPaciente={idPaciente}
						setIdPaciente={setIdPaciente}
						Paciente={Paciente}
						setPaciente={setPaciente}
						guardarCambios={() => guardarCambios()}
						ErroresFormulario={ErroresFormulario}
						setErroresFormulario={setErroresFormulario}
						ModalErrores={ModalErrores}
						setModalErrores={setModalErrores}
					/>
				)}
			</div>
			<ModalesMisPacientes
				ErroresFormulario={ErroresFormulario}
				setErroresFormulario={setErroresFormulario}
				ModalErrores={ModalErrores}
				setModalErrores={setModalErrores}
				ModalCorrecto={ModalCorrecto}
				setModalCorrecto={setModalCorrecto}
				setViewFormPaciente={setViewFormPaciente}
				idPaciente={idPaciente}
				ModalBorrarPaciente={ModalBorrarPaciente}
				setModalBorrarPaciente={setModalBorrarPaciente}
				Paciente={Paciente}
				deletePaciente={deletePaciente}
				ModalPacienteDelteOk={ModalPacienteDelteOk}
				setModalPacienteDelteOk={setModalPacienteDelteOk}
				ModalPacienteDelteNoOk={ModalPacienteDelteNoOk}
				setModalPacienteDelteNoOk={setModalPacienteDelteNoOk}
			/>
		</>
	);
};
